const TaiZi_2=[
    {
        "type":"Contig",
        "MAX":"316575",
        "N10":"98707",
        "N20":"73764",
        "N30":"59390",
        "N40":"49013",
        "N50":"40109",
        "N60":"32401",
        "N70":"25383",
        "N80":"18356",
        "N90":"11009",
        "MIN":"50"
    },
    {
        "type":"Scaffold",
        "MAX":"199723421",
        "N10":"199723421",
        "N20":"199723421",
        "N30":"109781150",
        "N40":"109781150",
        "N50":"99717750",
        "N60":"84743421",
        "N70":"80831152",
        "N80":"65732730",
        "N90":"58843935",
        "MIN":"1000"
    }
]
export default TaiZi_2